let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("in0CI"), load("7YJqr"), load("fBYPG"), load("jCu7l"), load("c6MKV"), load("efZH2")]).then(() => parcelRequire('mS2VM'));